import { render, staticRenderFns } from "./QBOAdmin.vue?vue&type=template&id=ca6c6b4a&"
import script from "./QBOAdmin.vue?vue&type=script&lang=js&"
export * from "./QBOAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports